export default __webpack_public_path__ + "static/9-saturate-9e5d20adebd2d540a6fe007fbc308b9d.png";